<template>
    <div class="container"  v-title="'赛事认证管理办法'">
        <Navigation-bar id="navigation_bar" type="dark"></Navigation-bar>
        <div class="container_content">
            <div class="title">
                <h2>
                    <div @click.stop="setProjectList(!project.show)">
                        <span>{{project.name}}</span>
                        <YD-image :src="project.show?'icon/icon_下拉箭头_白色_向上':'icon/icon_下拉箭头_白色_向下'"></YD-image>
                    </div>
                    <div id="title_list" v-show="project.show">
                        <div class="title_list_content">
                            <ul>
                                <li v-for="(item,index) in projectData" :key="index">
                                    <div class="name" v-pressed 
                                        v-if="item.Children && item.Children.length > 0" 
                                        :class="{'childrenActive':project.activeIndex == index}"
                                        @click.stop="selectProject(0,index,item.Id,item.Name,item.Children)"
                                    >{{item.Name}}</div>
                                    <div class="name" v-pressed 
                                        v-else
                                        :class="{'active':project.activeIndex == index}"
                                        @click.stop="selectProject(0,index,item.Id,item.Name)"
                                    >{{item.Name}}</div>
                                    <ol
                                        v-if="item.Children && item.Children.length > 0" 
                                        v-show="project.activeIndex == index"
                                    >
                                        <li v-pressed 
                                            v-for="(subItem,subIndex) in item.Children" :key="subIndex"
                                            :class="{'active':project.CActiveIndex == subIndex}"
                                            @click.stop="selectProject(1,subIndex,subItem.Id,subItem.Name)"
                                        >{{subItem.Name}}</li>
                                    </ol>
                                </li>
                            </ul>
                        </div>
                        <div class="cover"></div>
                    </div>
                </h2>
                <YD-image class="logo" src="logo_新"></YD-image>
                <p class="subTitle">赛事认证管理办法</p>
            </div>
            <div class="nav" v-scrollShadow="roll">
                <span>跳转至</span>
                <ul>
                    <li @click="go('赛事认证')">赛事认证</li>
                    <li @click="go('积分排名')">积分排名</li>
                    <li @click="go('运动员等级评定')">运动员等级评定</li>
                </ul>
            </div>
            <div id="certification_regulation" v-scroll="roll">
                <div class="certification_regulation_content" v-html="contentHtml"></div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import {
    GetLayeredEventsList
} from '@/api'
export default {
    name: 'CertificationRegulation',
    data() {
        return {
            Id: this.$route.params.id,
            roll:0,
            project:{
                show:false,
                Id:0,
                name:'',
                oldIndex: -1,//未点击子选项前标记前一个大项的下标
                COldIndex: -1,//未点击子选项前标记前一个小项
                activeIndex:-1,//父选中
                CActiveIndex:-1,//子选中
            },
            projectData:[],
            contentHtml:''
        }
    },
    created(){
        GetLayeredEventsList().then(data=>{
            if(data.Code == 0){
                var arr = data.EventsList;
                this.projectData = arr;
                this.initProject();
            }
        })
    },
    mounted() {
        var _this = this;
        window.onclick=function(){
            _this.setProjectList(false);
        }
    },
    methods: {
        initProject(){
            var arr = this.projectData;
            var obj = this.project;
            if(arr.length > 0){
                var is = true;
                i:
                for(var i=0;i<arr.length;i++){
                    if(arr[i].Children && arr[i].Children.length > 0){
                        let Children = arr[i].Children;
                        for(var j=0;j<Children.length;j++){
                            if(this.Id == Children[j].Id){
                                obj.activeIndex = i;
                                obj.CActiveIndex = j;
                                obj.name = Children[j].Name;
                                obj.Id = Children[j].Id;
                                is = false;
                                break i;
                            }
                        }
                    }else if(this.Id == arr[i].Id){
                        obj.activeIndex = i;
                        obj.CActiveIndex = -1;
                        obj.name = arr[i].Name;
                        obj.Id = arr[i].Id;
                        is = false;
                        break ;
                    }
                }
                if(is){
                    obj.activeIndex = 0;
                    if(arr[0].Children && arr[0].Children.length > 0){
                        obj.CActiveIndex = 0;
                        obj.name = arr[0].Children[0].Name;
                        obj.Id = arr[0].Children[0].Id;
                    }else{
                        obj.CActiveIndex = -1;
                        obj.name = arr[0].Name;
                        obj.Id = arr[0].Id;
                    }
                }
            }
            this.getHtml(obj.name);
        },
        setProjectList(show){
            var obj = this.project;
            if(obj.show && obj.oldIndex != -1){
                obj.activeIndex = obj.oldIndex;
                obj.CActiveIndex = obj.COldIndex;
                obj.oldIndex = -1;
                obj.COldIndex = -1;
            }
            obj.show = show;
        },
        selectProject(type,index,id,name,children){
            var obj = this.project;
            var isSelect = false;
            if(type == 0){
                if(obj.activeIndex != index){
                    if(!children || children.length==0){
                        isSelect = true;
                    }else{
                        obj.oldIndex = obj.activeIndex;
                        obj.COldIndex = obj.CActiveIndex;
                    }
                    obj.activeIndex = index;
                    obj.CActiveIndex = -1;
                }
            }else{
                obj.CActiveIndex = index;
                isSelect = true;
            }
            if(isSelect){
                obj.name = name;
                obj.Id = id;
                obj.oldIndex = -1;
                obj.COldIndex = -1;
                obj.show = false;
                this.getHtml(obj.name);
            }
        },
        go(title){
            var _this = this;
            var titles = document.querySelectorAll('.certification_regulation_content .title1');
            titles.forEach(function(item,index){
                if(item.innerText == title){
                    _this.roll = item.offsetTop - 10;
                }
            })
        },
        getHtml(name){
            $.ajax({
                url:  process.env.VUE_APP_PUBLIC_URL + '/files/管理办法/'+name+'.html',
                header:{
                    "Content-Type":"text/html; charset=utf-8",
                    "Accept-Language":"zh-CN"
                },
                success:(data)=>{
                    this.contentHtml = data.split('images/').join(process.env.VUE_APP_PUBLIC_URL + '/files/管理办法/images/');
                    this.$nextTick(function(){
                        $.each($('.certification_regulation_content p'),function(index,item){
                            if(!$(item).is('.title1') && !$(item).is('.title2') && $(item).children('span').length==0){
                                $(item).css('padding-left','0.5rem');
                            }
                        })
                    });
                    this.roll = 0;
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/ProjectSelectTitle.scss";
.title{
    background: #1B1C1E;
    position: relative;
    h2{
        color: #FFFFFF;
    }
    .logo{
        width: 106px;
        height: 56px;
        position:absolute;
        right: 32px;
        top: 38px;
    }
    .subTitle{
        @include line-height(44px);
        font-size: 32px;
        color: #999999;
        font-weight: 400;
        margin-top: 6px;
    }
}
.nav{
    height: 76px;
    background: #FFFFFF;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    span{
        font-size: 26px;
        color: #999999;
        font-weight: 400;
    }
    ul{
        li{
            display: inline-block;
            @include line-height(44px);
            padding: 0 16px;
            background: #D9F4F7;
            border-radius: 22px;
            font-size: 26px;
            color: #0DB1C6;
            font-weight: 400;
            margin-left: 16px;
        }
    }
}
#certification_regulation{
    height: calc(100% - 274px);
    position: relative;
}
</style>
<style lang="scss">
#certification_regulation{
    .certification_regulation_content{
        padding: 0 40px;
        padding-top: 40px;
        box-sizing: border-box;
        p{
            max-height: 100%;
            font-size: 26px;
            color: #4D5561;
            line-height: 42px;
            font-weight: 400;
            // position: relative;
            // padding-left: 50px;
            // box-sizing: border-box;
            margin-bottom: 24px;
            display: flex;
            .num{
                @include line-height(40px);
                padding-right: 8px;
                font-size: 28px;
                color: #BFC1C5;
                letter-spacing: 0;
                font-weight: 700;
                white-space: nowrap;
                // position: absolute;
                // top: 0;
                // left: 0;
            }
        }

        p.title1{
            display: inline-block;
            @include line-height(56px);
            padding: 0 34px;
            background: #1B1C1E;
            border-radius: 28px;
            font-size: 28px;
            color: #FFFFFF;
            font-weight: 600;
            text-align: center;
        }
        p.title2{
            min-height: 40px;
            line-height: 40px;
            font-size: 28px;
            color: #1B1C1E;
            font-weight: 600;
            padding-left: 0;
            .num{
                color: #1B1C1E;
                margin-right: 5px;
                padding: 0;
                position: static;
                letter-spacing: 0;
            }
        }
        p + .title2,
        img + .title1,
        img + .title2{
            margin-top: 56px;
        }
        p + .title1{
            margin-top: 32px;
        }
        .title1 + .title2,
        .title1 + p{
            margin-top: 8px;
        }
        .title2 + p,
        img + p{
            margin-top: 32px;
        }
        img{
            width: 100%;
            height: auto;
        }
    }
}
</style>